// Uncomment if you are building a library with a component.
// import { LibraryTemplateLibComponent } from './ngx-loader-component/ngx-loader.component';
// Uncomment if you are building a library with a service.
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Library Files

// Library Modules
import { LoaderFullpageModule } from './components/loader-fullpage/loader-fullpage.module';
import { LoaderDisablesFormGroupModule } from './directives/loader-disables-form-group/loader-disables-form-group.module';
import { LoaderTogglesClassModule } from './directives/loader-toggles-class/loader-toggles-class.module';
import { LoaderBusService } from './services/loader-bus/loader-bus.service';
import { LoadingInterceptor } from './services/loader-interceptor/loader-interceptor.service';

/**
 * The Loader library module. By importing this module in to one of your own, your module gains access to the library directives and
 * components. Additionally, any necessary default providers and interceptors will be set up.
 *
 * ### Example
 * ```
...
imports: [ LoaderModule.forRoot() ]
...
 ```
 */
@NgModule({
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        FormsModule,
        // Library modules
        LoaderFullpageModule,
        LoaderDisablesFormGroupModule,
        LoaderTogglesClassModule
    ],
    declarations: [],
    exports: [ LoaderFullpageModule, LoaderDisablesFormGroupModule, LoaderTogglesClassModule ]
})
export class LoaderModule {
    /** Use this to initialize the the module's providers. */
    static forRoot (): ModuleWithProviders<LoaderModule> {
        return {
            ngModule: LoaderModule,
            providers: [ LoaderBusService, { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true } ]
        };
    }
}
